<div class="page-container">
  <p-card class="grow" [pt]="{ body: { class: 'uvi-card-body' } }">
    <ng-content class="h-full"></ng-content>
  </p-card>
</div>
